import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

class ThreeImageAd extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.threeImageAd}>
                {content.map((item, index) => {
                    return (
                        <a className={styles.threeImage} key={index} href={item.url}>
                            <img src={formatImageWebpAuto(item.imageUrl, 206, 116)} />
                        </a>
                    );
                })}
            </div>
        );
    }
}

export default errorBoundary(ThreeImageAd);
